// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__UHJ4Q","unreadBadge":"styles_unreadBadge__2H_o5","modalContent":"styles_modalContent__3t4lY","modal":"styles_modal__Xpnc7"};